import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser"

function DocumentLayout() {
    const { isAdmin, isLoading } = useCurrentUser()
    const navigate = useNavigate()

    useEffect(() => {
        if (!isLoading && !isAdmin) {
            navigate({ to: "/agent/policy" })
        }
    }, [isAdmin, isLoading, navigate])

    if (isLoading || !isAdmin) {
        return null
    }

    return (
        <main className="flex-1 overflow-y-auto">
            <Outlet />
        </main>
    )
}

export const Route = createFileRoute("/_authenticated/agent/document")({
    component: DocumentLayout,
})
